import { render, staticRenderFns } from "./ProjectModal_Team.vue?vue&type=template&id=84da1a70&scoped=true&"
import script from "./ProjectModal_Team.vue?vue&type=script&lang=js&"
export * from "./ProjectModal_Team.vue?vue&type=script&lang=js&"
import style0 from "./ProjectModal_Team.vue?vue&type=style&index=0&id=84da1a70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84da1a70",
  null
  
)

export default component.exports